import { api } from "@/lib/api";

/**
 * Logger d'activité IA élève (fire-and-forget).
 * N'envoie que si l'utilisateur connecté est un élève.
 * Types : view_course | start_quiz | complete_quiz | start_assignment |
 *         complete_assignment | chat_message | view_result | revision
 */
export function logIA(activity_type, extras = {}) {
  try {
    const raw = localStorage.getItem("mazid_user");
    if (!raw) return;
    const user = JSON.parse(raw);
    if (user?.role !== "student") return;
    api.post("/sprint-f/ia-usage/log", { activity_type, ...extras }).catch(() => {});
  } catch {
    // silencieux — le tracking ne doit jamais bloquer l'UX
  }
}
